import {
  Button,
  CrossIcon,
  useToastContext,
} from '@trufla-technology/trumarket-react-design-system';
import { capitalize } from 'lodash';
import { TeamType } from '../../types/User';
import './TeamCardContent.scss';
import { useReadableDateTime } from '../../hooks/useReadableDateTime';
import { useUnassignUsersFromTeams } from '@trufla-technology/trufla-trudomain/dist/lib/truMarket';
import { useHistory, useParams } from 'react-router';
import { useAuthContext } from '@trufla-technology/trufla-trudomain/dist/lib';

type Props = {
  team: TeamType;
  refetchTeams?: () => void;
  lastUpdated?: boolean;
  width?: string;
};

export const TeamCardContent = ({
  team: { name, createdAt, updatedAt, key, usersCount },
  refetchTeams,
  lastUpdated,
  width,
}: Props) => {
  const { isPermitted } = useAuthContext();
  const { key: userKey } = useParams<any>();
  const readableDateFormat = useReadableDateTime();
  const toaster = useToastContext();
  const unassignUserFromTeams = useUnassignUsersFromTeams();
  const history = useHistory();

  const handleUnassignUser = async (e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation();
    try {
      await unassignUserFromTeams({
        unassigning: [
          {
            teamKey: key!,
            userKey: userKey,
          },
        ],
      });
      refetchTeams?.();
    } catch (err) {
      toaster.error('Failed to unassign user');
    }
  };

  return (
    <div
      className="team-card"
      onClick={() => history.push(`/configurations/teams/details/${key}`)}
    >
      <div className="card-header">
        <span className="user-count">
          <p>{usersCount}</p>
        </span>
        <span>{capitalize(name)}</span>
      </div>
      <div className="card-body">
        <div className="card-body-details">
          <span>Created At</span>
          <p>{readableDateFormat(createdAt!, 'dd/LL/yyyy, h:mma')}</p>
        </div>
        {lastUpdated ? (
          <div className="card-body-details">
            <span>Last Modified</span>
            <p>{readableDateFormat(updatedAt!, 'dd/LL/yyyy, h:mma')}</p>
          </div>
        ) : (
          isPermitted('unassignUsersFromTeams') && (
            <Button onClick={(e) => handleUnassignUser(e!)}>
              <CrossIcon size="extra-small" fill="var(--tru-shuttle-grey)" />
            </Button>
          )
        )}
      </div>
    </div>
  );
};
